<template>
  <main>
    <crumbs :crumbs="crumbs"></crumbs>
    <div class="wrap">
      <div class="title-box">
        <div class="tit">我们的赞助商</div>
        <div class="desc">了解戴尔的赞助商如何帮助企业推动数字化转型，您可在此观看赞助商视频及下载相关资料。</div>
      </div>
      <div class="sponsor" v-if="showSponsor(1)">
        <div class="title">全球赞助商</div>
        <div class="line"></div>
        <div class="list list-l">
          <div class="cen">
            <div class=" item" v-for="item in sponsor" v-if="item.type == 1" @click="toSponsorDetail(item)">
              <div class="logo" :style="{backgroundImage:'url('+util.autoImage(item.logo)+')'}"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="sponsor" v-if="showSponsor(3)">
        <div class="title">赞助商</div>
        <div class="line"></div>
        <div class="list list-l">
          <div class="cen">
            <div class="left item" v-for="item in sponsor" v-if="item.type == 3" @click="toSponsorDetail(item)">
              <div class="logo" :style="{backgroundImage:'url('+util.autoImage(item.logo)+')'}"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="sponsor" v-if="showSponsor(2)">
        <div class="title">合作伙伴赞助商</div>
        <div class="line"></div>
        <div class="list list-l">
          <div class="cen">
            <div class=" item" v-for="item in sponsor" v-if="item.type == 2" @click="toSponsorDetail(item)">
              <div class="logo" :style="{backgroundImage:'url('+util.autoImage(item.logo)+')'}"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="data-loading" v-if="show_loading">
        <loading></loading>
      </div>
    </div>
  </main>
</template>

<script>
    import Crumbs from "../../../components/pc/Crumbs";
    import Loading from "../../../components/pc/Loading";
    export default {
        name: 'sponsor',
        data() {
            return {
                query:"",
                sponsor:[],
                adv:{},
                show_loading:true,
            }
        },
        components:{
            Loading,
            Crumbs
        },
        computed:{
            crumbs() {
				return {title:"赞助商",min_title:"sponsor"}
            },
        },
        methods: {
            toSponsorDetail(item,link=false){
                if(item.show_detail == 2){
                    this.util.toLink(item.link,'','_blank');
                }else{
                    var url = "/sponsor/detail?sponsor_id="+item.id;
                    if(this.$store.state.user_info.id){
                        this.util.toLink(url);
                    }else{
                        this.util.toLink(url);
                    }
                }
            },
            showSponsor(type){
                var flag = false;
                for(var i =0;i<this.sponsor.length;i++){
                    if(this.sponsor[i].type == type){
                        flag = true;
                    }
                }
                return flag;
            },
            getSponsorList(){
                this.show_loading = true;
                this.http.request({
                    api:"sponsor/getSponsorList",
                    success:(res)=>{
                        this.sponsor = res.list;
                        this.show_loading = false;
                        this.$nextTick(()=>{
                            this.util.showBottom(true);
                        })
                    }
                })
            },
        },
        mounted() {
            this.query = this.$route.query;
            this.getSponsorList();
        }
    }
</script>

<style lang="scss" type="text/scss" scoped>
    .wrap{padding-top: 20px;padding-bottom: 50px;
        .title-box{padding:30px;background: #fff;width: 1140px;margin:0 auto;box-shadow:0 0 10px 2px rgba(0,0,0,.1);
            .tit{font-size: 20px;line-height: 16px;border-left: 4px solid #0176ce;padding-left: 10px;font-weight: bold;}
            .desc{font-size: 18px;margin-top: 10px;line-height: 23px;color:#565656;padding-left: 14px;white-space: pre-line}
        }
        .sponsor{margin: 30px auto 0;
            .title{font-size: 28px;text-align: center}
            .line{width: 230px;height:2px;margin: 2px auto 0; background: url("~@/assets/image/45.png") no-repeat center center;background-size: contain;}
            .list{width: 1200px; margin: 30px auto;overflow: hidden;padding: 30px 0 0;text-align: center;
				        .cen{display: inline-block;}
                .item{width: 520px;float: left; background: #fff;cursor: pointer;transition: all .3s ease;margin-bottom: 30px;padding: 30px 0;text-align: center;margin-right: 50px;
                    .logo{width: 200px;height:100px;margin: 0 auto; background: url("~@/assets/image/22.png") no-repeat center center;background-size: contain;}
                }
                .item:hover{box-shadow: 0 0 20px 5px rgba(0,0,0,.1);transition: all .3s ease;}
            }
            .list.list-l{text-align: center;
                .cen{display: inline-block;}
                .item{width: 320px;margin-right: 20px;padding:10px 30px;margin-bottom: 20px;
                    .logo{width: 200px;height:100px;background: url("~@/assets/image/22.png") no-repeat center center;background-size: contain;}
                }
                .item:nth-child(3n){margin-right: 0;}
            }
        }
    }
</style>

